// extracted by mini-css-extract-plugin
module.exports = {"component":"header-carousel-search_component__eWsiY themeLight"};